import { PricelistOffersGetByIdOffers } from "../../../../services/orders/pricelist-offers-get-by-id/types";

export type StatusChandleDataResponse = {
    view:OfferViewComponent,
    data:PricelistOffersGetByIdOffers[],
};
    
export enum OfferViewComponent {
    firstView = 0,
    theOfferForThisOrderHasAlreadyBeenPreApproved=1,
    theOfferForTheGivenOrderHasAlreadyBeenRejected=2, 
    theOfferHasBennFinallyAcceptedOrThereIsNoOfferForFinalAcceptance=3,
    finalOffertView=4,
};


export const getMessageOfErrorsDebugUnlogedClient = (type: number):string => {
    switch (type) {
      case 0:
        return "Zamówienie wstepnie zaakceptowane obecnie oczekuje na przedstawienie ostatecznej oferty przez operatora";
      case 1:
        return "Zamówienie ostatecznie zaakceptowane oczekuje na realizację";
      case 2:
        return "Zrezygnowano z zamówienia";
      case 3:
        return "Zamówienie jest w trakcie realizacji";
      case 4:
        return "Twój token dostępu wygasł/ Czas na potwierdzenie oferty miną";
      case 5:
        return "Niepoprawny token";
      case 6:
        return "Nie masz dostępu do tych treści";
      case 7:
        return "Nie znaleziono takiego zamówienia";
      default: 
        return "Wystąpił Błąd. Skontaktuj się z administratorem strony";
    }
  };

  export const getNumberOfErrorsDebugUnlogedClient = (errors_debug: string):number => {
    switch (errors_debug) {
      case "OrderPreAccepted zamówienie ma status \"Wstepna_akceptacja\" i czeka na operatora żeby wysłał powiadomienie z prośbą o ostateczną akceptację klienta":
        return 0;
      case "OrderFinalAccepted zamówienie ma status \"Do_ostatecznej_akceptacji\" i czeka na  realizację":
        return 1;
      case "OrderResigned zamówienie ma status \"Rezygnacja\"":
        return 2;
      case "OrderInRealization zamówienie ma status w trakcie realizacji":
        return 3;
      case "ConfirmingOffersTokenExpired":
        return 4;  
      case "TokenUnauthorizedExpired":
        return 5;   
      case "access denied":
        return 6;          
      case "NotFound":
        return 7;      
      default:
        return 8;
    }
  };